// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_th-0";